import { render, staticRenderFns } from "./Mining.vue?vue&type=template&id=740018ee&scoped=true"
import script from "./Mining.vue?vue&type=script&lang=js"
export * from "./Mining.vue?vue&type=script&lang=js"
import style0 from "./Mining.vue?vue&type=style&index=0&id=740018ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740018ee",
  null
  
)

export default component.exports